import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ConfirmService } from '@tymes4-shared';
import { BackOfficeIdentificationOverrideArgs, Country, CountryService, IdentificationStateEnum, IdentificationStatusReason, IdVerificationService, UpdateIdArgs } from '../../api';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-manual-identification-document-override',
    templateUrl: './manual-identification-document-override.component.html',
    styleUrls: ['./manual-identification-document-override.component.scss'],
    standalone: false
})
export class ManualIdentificationDocumentOverrideComponent implements OnInit {

  public form: FormGroup;
  public customerId: number;
  public identificationReasons: Array<IdentificationStatusReason> = null;
  public countries: Array<Country> = null;

  constructor(
    @Inject(MAT_DIALOG_DATA) public passedData: any,
    public dialogRef: MatDialogRef<ManualIdentificationDocumentOverrideComponent>,
    private idVerificationService: IdVerificationService,
    private countryService: CountryService,
    private confirmService: ConfirmService,
    private translate: TranslateService,
  ) { }

  ngOnInit(): void {
    this.customerId = this.passedData.customerId;

    this.idVerificationService.getStatusReasons().subscribe( (reasons: Array<IdentificationStatusReason>) => {
      this.identificationReasons = reasons;
    });

    this.countryService.listAllCountries().subscribe((countries: Array<Country>) => {
      this.countries = countries;
    });

    this.form = new FormGroup({
      FirstName: new FormControl('', Validators.required),
      LastName: new FormControl('', Validators.required),
      DateOfBirth: new FormControl(null, Validators.required),
      CountryId: new FormControl(null, Validators.required),
      DocumentType: new FormControl('', Validators.required),
      IdentificationStatusReasonId: new FormControl(null, Validators.required),
      ExpirationDate: new FormControl(null, Validators.required)
    });
  }

  submit() {
    const formValues = this.form.value;
    const args : BackOfficeIdentificationOverrideArgs = {
      CustomerId: this.customerId,
      FirstName: formValues.FirstName,
      LastName: formValues.LastName,
      DateOfBirth: formValues.DateOfBirth,
      CountryId: formValues.CountryId,
      DocumentType: formValues.DocumentType,
      IdentificationStatusReasonId: formValues.IdentificationStatusReasonId,
      ExpirationDate: formValues.ExpirationDate
    };

    this.confirmService.confirm({
      title: this.translate.instant('CUSTOMER.MANUAL-IDENTIFICATION-OVERRIDE-DIALOG.CONFIRM.TITLE'),
      message: this.translate.instant('CUSTOMER.MANUAL-IDENTIFICATION-OVERRIDE-DIALOG.CONFIRM.MSG'),
      okonly: false
    }).subscribe((confirm: boolean) => {
      if (!confirm) {
        return;
      }

      this.idVerificationService.createIdentificationOverride(args).subscribe(() => {
        this.dialogRef.close(true);
      }, err => {
        this.confirmService.confirm({
          title: this.translate.instant('CUSTOMER.MANUAL-IDENTIFICATION-OVERRIDE-DIALOG.ERROR.TITLE'),
          message: this.translate.instant('CUSTOMER.MANUAL-IDENTIFICATION-OVERRIDE-DIALOG.ERROR.MSG'),
          okonly: true
        }).subscribe(() => {
          this.dialogRef.close(false);
        });
      });
    });
  }

  updateIdentificationStatus(newStatus: IdentificationStateEnum, reason: string) {
    const args: UpdateIdArgs = {
      CustomerId: this.customerId,
      Status: newStatus,
      Reason: reason
    }

    return this.idVerificationService.updateVerificationStatus(args);
  }

}
